import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

export default (ChildComponent) => {
    const RequirePremiumMembership = (props) => {
        if (props.auth.user.isPowered) {
            return <ChildComponent {...props} />;
        }
        return <Redirect to={`/home`} />;
    };

    function mapStateToProps({ auth }) {
        return { auth };
    }

    return connect(mapStateToProps)(withRouter(RequirePremiumMembership));
};
